import * as React from 'react';
import { ChangeEvent, FocusEvent, KeyboardEvent } from 'react';

interface InputProps {
    id?: string;
    interval?: number;
    value: string | number;
    className?: string;
    disabled?: boolean;
    type: string;
    placeholder?: string;
    onAfterChange: () => void;
    onBlur?: () => void;
    onChange: (value: string) => void;
    onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
    onChangeCondition?: (value: string) => boolean;
    onKeyDown?: () => void;
    onClick?: () => void;
    onCancel?: () => void;
    tabIndex?: number;
    autocomplete?: string;
}

export class Input extends React.Component<InputProps, object> {
    private interval: number;
    private timer: NodeJS.Timeout | undefined;

    constructor(props: InputProps) {
        super(props);

        this.interval = props.interval ?? 500;
    }

    componentDidMount() {
        if (this.timer) clearTimeout(this.timer);
    }

    onChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (this.timer) clearTimeout(this.timer);
        const value = event.target.value;

        if (!this.props.onChangeCondition || this.props.onChangeCondition(value)) {
            this.props.onChange(value);
            this.timer = setTimeout(this.triggerChange, this.interval);
        }
    };

    onKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            if (this.props.onCancel) {
                this.props.onCancel();
            }
        } else if (event.key === 'Enter') {
            this.props.onKeyDown ? this.props.onKeyDown() : this.props.onAfterChange();
        }
    };

    triggerChange = () => {
        if (this.props.value) this.props.onAfterChange();
    };

    onBlur = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.props.onAfterChange();

        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };

    render() {
        return (
            <input
                type={this.props.type}
                id={this.props.id}
                disabled={this.props.disabled}
                className={this.props.className}
                onFocus={this.props.onFocus}
                onBlur={this.onBlur}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
                onClick={this.props.onClick}
                placeholder={this.props.placeholder}
                value={this.props.value}
                tabIndex={this.props.tabIndex}
                autoComplete={this.props.autocomplete}
            />
        );
    }
}
